module.exports = __webpack_public_path__ + "static/img/banner011.607010f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/banner011.png
// module id = prE5
// module chunks = 1